/* tslint:disable */
/**
 * IDP Service API
 * Handles Identity Provider (IDP) logic and authentication flows
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import axios from 'axios';
import { AuthenticationApi, MFAApi } from './lib/api.js';
import { Configuration } from './lib/configuration.js';
export * from './lib/index.js';
export { listLinkedProviders, unlinkSocialProvider } from './lib/helpers.js';
export { createIdpClient } from './client.js';
export { singleFlightRefresh, singleFlightRefreshFetch, isRefreshInflight, isRefreshBlocked, blockRefresh, resetRefreshBlock, RefreshBlockedError, __resetInflightRefreshForTests, __resetRefreshGuardForTests, } from './lib/refresh-single-flight.js';
const DEFAULT_IDP_BASE = '';
function sanitizeBase(input) {
    if (input === undefined || input === null)
        return undefined;
    const trimmed = input.trim();
    if (!trimmed)
        return undefined;
    if (trimmed === '/')
        return '';
    return trimmed.replace(/\/$/, '');
}
function isDevProxyHost() {
    if (typeof window === 'undefined')
        return false;
    try {
        const host = window.location?.hostname ?? '';
        if (!host)
            return false;
        return (host.endsWith('.dev.digiwedge.com') ||
            host.endsWith('.uat.digiwedge.com') ||
            host.endsWith('.local.digiwedge.com') ||
            host === 'localhost' ||
            host === '127.0.0.1');
    }
    catch {
        return false;
    }
}
const fromProcess = typeof process !== 'undefined' ? process.env?.['VITE_IDP_BASE_URL'] : undefined;
const importMetaEnv = globalThis.importMetaEnv;
const fromImportMeta = sanitizeBase(importMetaEnv?.VITE_IDP_BASE_URL);
const envBase = sanitizeBase(fromProcess ?? fromImportMeta ?? undefined);
const sanitizedDefault = sanitizeBase(DEFAULT_IDP_BASE) ?? DEFAULT_IDP_BASE;
const preferSameOrigin = isDevProxyHost() && (!envBase || envBase === sanitizedDefault);
const IDP_BASE_URL = preferSameOrigin ? '' : (envBase ?? sanitizedDefault);
const browserBaseOptions = typeof window !== 'undefined' ? { headers: {} } : undefined;
const config = new Configuration({ basePath: IDP_BASE_URL, baseOptions: browserBaseOptions });
if (typeof window !== 'undefined') {
    const headers = (config.baseOptions?.headers ?? {});
    delete headers['User-Agent'];
    delete headers['user-agent'];
    config.baseOptions = { ...config.baseOptions, headers };
}
export let authApi = new AuthenticationApi(config);
export let mfaApi = new MFAApi(config);
let tokenDeliveryMode = 'json';
export const verifyEmail = (params) => {
    const base = authApi.basePath ?? IDP_BASE_URL;
    const axiosInst = authApi.axios || axios;
    const preferRelative = base === '' && typeof window !== 'undefined';
    const prefix = preferRelative ? '' : base || sanitizedDefault;
    const target = prefix ? `${prefix}/api/auth/verify-email` : '/api/auth/verify-email';
    return axiosInst.post(target, params);
};
/**
 * Bind the globally-exported APIs to a specific IdpClient instance.
 * Useful in apps that supply a custom axios + basePath via IdpProvider.
 */
export function bindIdpClient(client) {
    authApi = client.authApi;
    mfaApi = client.mfaApi;
    tokenDeliveryMode = client.tokenDelivery ?? 'json';
}
/**
 * Set the base URL for the global auth/mfa APIs using default axios instances.
 * Use this in apps where you don't need custom interceptors.
 */
export function setIdpBaseUrl(basePath) {
    const base = sanitizeBase(basePath) ?? IDP_BASE_URL;
    const nextConfig = new Configuration({ basePath: base });
    if (typeof window !== 'undefined') {
        const headers = (nextConfig.baseOptions?.headers ?? {});
        delete headers['User-Agent'];
        delete headers['user-agent'];
        nextConfig.baseOptions = { ...nextConfig.baseOptions, headers };
    }
    authApi = new AuthenticationApi(nextConfig);
    mfaApi = new MFAApi(nextConfig);
    tokenDeliveryMode = 'json';
}
export function getTokenDeliveryMode() {
    if (typeof document !== 'undefined') {
        const meta = document.querySelector('meta[name="idp-token-delivery"]');
        const value = meta?.content?.trim().toLowerCase();
        if (value === 'cookie')
            return 'cookie';
        if (value === 'json')
            return 'json';
    }
    if (typeof window !== 'undefined') {
        const value = window.APP_CONFIG?.idpTokenDelivery
            ?.trim()
            .toLowerCase();
        if (value === 'cookie')
            return 'cookie';
        if (value === 'json')
            return 'json';
    }
    return tokenDeliveryMode;
}
//# sourceMappingURL=index.js.map